import { render, staticRenderFns } from "./autoAssign.vue?vue&type=template&id=b13bd79a&scoped=true"
import script from "./autoAssign.vue?vue&type=script&lang=js"
export * from "./autoAssign.vue?vue&type=script&lang=js"
import style0 from "./autoAssign.vue?vue&type=style&index=0&id=b13bd79a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13bd79a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b13bd79a')) {
      api.createRecord('b13bd79a', component.options)
    } else {
      api.reload('b13bd79a', component.options)
    }
    module.hot.accept("./autoAssign.vue?vue&type=template&id=b13bd79a&scoped=true", function () {
      api.rerender('b13bd79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/ShippingManagement/autoAssign.vue"
export default component.exports